/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssetExpenseResponse } from './AssetExpenseResponse';
import {
    AssetExpenseResponseFromJSON,
    AssetExpenseResponseFromJSONTyped,
    AssetExpenseResponseToJSON,
    AssetExpenseResponseToJSONTyped,
} from './AssetExpenseResponse';
import type { AssetMaintenanceExpenseResponse } from './AssetMaintenanceExpenseResponse';
import {
    AssetMaintenanceExpenseResponseFromJSON,
    AssetMaintenanceExpenseResponseFromJSONTyped,
    AssetMaintenanceExpenseResponseToJSON,
    AssetMaintenanceExpenseResponseToJSONTyped,
} from './AssetMaintenanceExpenseResponse';
import type { AssetExpenseSummaryResponse } from './AssetExpenseSummaryResponse';
import {
    AssetExpenseSummaryResponseFromJSON,
    AssetExpenseSummaryResponseFromJSONTyped,
    AssetExpenseSummaryResponseToJSON,
    AssetExpenseSummaryResponseToJSONTyped,
} from './AssetExpenseSummaryResponse';

/**
 * 
 * @export
 * @interface AssetExpensesTabResponse
 */
export interface AssetExpensesTabResponse {
    /**
     * 
     * @type {string}
     * @memberof AssetExpensesTabResponse
     */
    clientId: string;
    /**
     * 
     * @type {boolean}
     * @memberof AssetExpensesTabResponse
     */
    hasIllnessExtraCosts: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof AssetExpensesTabResponse
     */
    illnessExtraCostAmount: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetExpensesTabResponse
     */
    paysCostsAlone: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetExpensesTabResponse
     */
    costSharingExplanation: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetExpensesTabResponse
     */
    expenseRemarks: string | null;
    /**
     * 
     * @type {Array<AssetExpenseResponse>}
     * @memberof AssetExpensesTabResponse
     */
    expenses: Array<AssetExpenseResponse>;
    /**
     * 
     * @type {AssetMaintenanceExpenseResponse}
     * @memberof AssetExpensesTabResponse
     */
    maintenance: AssetMaintenanceExpenseResponse;
    /**
     * 
     * @type {AssetExpenseSummaryResponse}
     * @memberof AssetExpensesTabResponse
     */
    summary: AssetExpenseSummaryResponse;
}

/**
 * Check if a given object implements the AssetExpensesTabResponse interface.
 */
export function instanceOfAssetExpensesTabResponse(value: object): value is AssetExpensesTabResponse {
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    if (!('hasIllnessExtraCosts' in value) || value['hasIllnessExtraCosts'] === undefined) return false;
    if (!('illnessExtraCostAmount' in value) || value['illnessExtraCostAmount'] === undefined) return false;
    if (!('paysCostsAlone' in value) || value['paysCostsAlone'] === undefined) return false;
    if (!('costSharingExplanation' in value) || value['costSharingExplanation'] === undefined) return false;
    if (!('expenseRemarks' in value) || value['expenseRemarks'] === undefined) return false;
    if (!('expenses' in value) || value['expenses'] === undefined) return false;
    if (!('maintenance' in value) || value['maintenance'] === undefined) return false;
    if (!('summary' in value) || value['summary'] === undefined) return false;
    return true;
}

export function AssetExpensesTabResponseFromJSON(json: any): AssetExpensesTabResponse {
    return AssetExpensesTabResponseFromJSONTyped(json, false);
}

export function AssetExpensesTabResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetExpensesTabResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'clientId': json['clientId'],
        'hasIllnessExtraCosts': json['hasIllnessExtraCosts'],
        'illnessExtraCostAmount': json['illnessExtraCostAmount'],
        'paysCostsAlone': json['paysCostsAlone'],
        'costSharingExplanation': json['costSharingExplanation'],
        'expenseRemarks': json['expenseRemarks'],
        'expenses': ((json['expenses'] as Array<any>).map(AssetExpenseResponseFromJSON)),
        'maintenance': AssetMaintenanceExpenseResponseFromJSON(json['maintenance']),
        'summary': AssetExpenseSummaryResponseFromJSON(json['summary']),
    };
}

export function AssetExpensesTabResponseToJSON(json: any): AssetExpensesTabResponse {
    return AssetExpensesTabResponseToJSONTyped(json, false);
}

export function AssetExpensesTabResponseToJSONTyped(value?: AssetExpensesTabResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clientId': value['clientId'],
        'hasIllnessExtraCosts': value['hasIllnessExtraCosts'],
        'illnessExtraCostAmount': value['illnessExtraCostAmount'],
        'paysCostsAlone': value['paysCostsAlone'],
        'costSharingExplanation': value['costSharingExplanation'],
        'expenseRemarks': value['expenseRemarks'],
        'expenses': ((value['expenses'] as Array<any>).map(AssetExpenseResponseToJSON)),
        'maintenance': AssetMaintenanceExpenseResponseToJSON(value['maintenance']),
        'summary': AssetExpenseSummaryResponseToJSON(value['summary']),
    };
}

